/**
 * Grundbuchmeldung API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MeldungsEmpfaengerId } from './meldungsEmpfaengerId';
import { TagebuchNummerSearchRequest } from './tagebuchNummerSearchRequest';


export interface Ech0134GrundbuchmeldungSearchRequest { 
    empfaengerId?: MeldungsEmpfaengerId;
    tagebuchNummer?: TagebuchNummerSearchRequest;
    status?: Ech0134GrundbuchmeldungSearchRequest.StatusEnum;
    datumVersandVon?: string;
    datumVersandBis?: string;
    grundbuchmeldungSort?: Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum;
    sortDirection?: Ech0134GrundbuchmeldungSearchRequest.SortDirectionEnum;
    offset?: number;
    limit?: number;
}
export namespace Ech0134GrundbuchmeldungSearchRequest {
    export type StatusEnum = 'NICHT_ERSTELLT' | 'ERSTELLT' | 'FEHLERHAFT_ERSTELLT' | 'FEHLERHAFT_GESENDET' | 'GESENDET';
    export const StatusEnum = {
        NICHT_ERSTELLT: 'NICHT_ERSTELLT' as StatusEnum,
        ERSTELLT: 'ERSTELLT' as StatusEnum,
        FEHLERHAFT_ERSTELLT: 'FEHLERHAFT_ERSTELLT' as StatusEnum,
        FEHLERHAFT_GESENDET: 'FEHLERHAFT_GESENDET' as StatusEnum,
        GESENDET: 'GESENDET' as StatusEnum
    };
    export type GrundbuchmeldungSortEnum = 'GESCHAEFTS_NUMMER' | 'EMPFAENGER_BEZEICHNUNG' | 'EMPFAENGER_SEDEX_ID' | 'MELDUNGS_STATUS' | 'DATUM_VERSAND';
    export const GrundbuchmeldungSortEnum = {
        GESCHAEFTS_NUMMER: 'GESCHAEFTS_NUMMER' as GrundbuchmeldungSortEnum,
        EMPFAENGER_BEZEICHNUNG: 'EMPFAENGER_BEZEICHNUNG' as GrundbuchmeldungSortEnum,
        EMPFAENGER_SEDEX_ID: 'EMPFAENGER_SEDEX_ID' as GrundbuchmeldungSortEnum,
        MELDUNGS_STATUS: 'MELDUNGS_STATUS' as GrundbuchmeldungSortEnum,
        DATUM_VERSAND: 'DATUM_VERSAND' as GrundbuchmeldungSortEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
}


